export const roles = {
  cleaner: 'cleaner',
  customer: 'customer',
  contractor:'contractor'
};
